import { useSendHelpForm } from "@/api/help/hooks"
import Button from "@/components/shared/Button"
import showErrorToast from "@/components/shared/Toaster/showErrorToast"
import Typography from "@/components/shared/Typography"
import { Email } from "@/components/shared/inputs/Email"
import { inputStylingProps } from "@/components/shared/inputs/utils"
import { FormProvider, useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { TextAreaField } from "rtu-components"

enum FormKeys {
  EMAIL = "email",
  NOTE = "note",
}
interface FormData {
  [FormKeys.EMAIL]: string
  [FormKeys.NOTE]: string
}

const DEFAULT_VALUES: FormData = { [FormKeys.NOTE]: "", [FormKeys.EMAIL]: "" }

export const ContactForm = () => {
  const { t } = useTranslation()

  const { mutateAsync: sendHelpForm } = useSendHelpForm()

  const form = useForm<FormData>({ defaultValues: DEFAULT_VALUES, mode: "onBlur" })
  const {
    formState: { dirtyFields, isValid },
  } = form

  const isDirty = Object.keys(dirtyFields).length === Object.keys(DEFAULT_VALUES).length
  const enableSubmit = isDirty && isValid

  const onSubmit = async (formData: FormData) => {
    try {
      await sendHelpForm({ email: formData[FormKeys.EMAIL], message: formData[FormKeys.NOTE] })
      form.reset()
    } catch (error) {
      showErrorToast(t("help.contact.error"))
    }
  }

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="rounded-lg bg-primary-700 ">
        <div className="flex flex-col ">
          <Typography type="h2" className="pb-4 text-primary-50">
            {t("help.contact.title")}
          </Typography>

          <Typography type="l" className="text-primary-200">
            {t("help.contact.subtitle")}
          </Typography>

          <div id="form" className="my-8 flex w-full flex-col gap-4">
            <Email />

            <TextAreaField
              renderLabel={() => (
                <Typography className="text-[13px] text-primary">{t("help.contact.question")}</Typography>
              )}
              name={FormKeys.NOTE}
              {...inputStylingProps}
              placeholder={t("help.contact.placeholder")}
            />

            <Button color="primary" className="mb-2 mt-6 w-fit" type="submit" disabled={!enableSubmit}>
              {t("help.contact.submit")}
            </Button>
          </div>
        </div>
      </form>
    </FormProvider>
  )
}
